<template>
  <div class="location">
    <div class="row">
      <div class="column">
        <div class="location__info">
          <h2 v-html="$t('block_location_title')">
          </h2>
          <p v-html="$t('block_location_address')">
          </p>
          <core-button :href="href" target="_blank" class="btn form">
            {{ $t('block_location_cta_apply') }}
          </core-button>
        </div>
      </div>
      <a class="column location__map" :href="$t('block_location_map_link')" target="_blank">
        <span class="sr-only">{{ $t('block_location_map_alt') }}</span>
        <static-map :google-api-key="apiKey" :signature="signature" :format="format" :markers="markers" :zoom="zoom" :center="center" :size="size" :type="type" :language="language" :customStyle="customStyle"></static-map>
      </a>
    </div>
  </div>
</template>

<script>
import { getGeneralApplication } from '@/services/contentService.js'
import StaticMap from '@/components/StaticMap.vue'

export default {
  name: 'C-Location',
  data () {
    return {
      // WARNING : each time a parameter bellow is changed regarding the google map, we shoud sign again (https://developers.google.com/maps/documentation/maps-static/get-api-key#apikey-signatures)
      apiKey: process.env.VUE_APP_GMAP_API_KEY,
      signature: process.env.VUE_APP_GMAP_API_SIGNATURE,
      zoom: 15,
      center: '46.39926572225088,6.215919367131669',
      format: 'gif',
      language: 'en',
      markers: [
        {
          lat: 46.39926572225088,
          lng: 6.215919367131669,
          size: 'small',
          icon: 'https://www.hublot.com/joboffers/map-pin.png'
        }
      ],
      type: 'roadmap',
      size: [700, 480],
      href: '',
      customStyle: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xe9e9e9'
            },
            {
              lightness: '17'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xf5f5f5'
            },
            {
              lightness: '20'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '0xffffff'
            },
            {
              lightness: '17'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '0xffffff'
            },
            {
              lightness: '19'
            },
            {
              weight: '0.2'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xffffff'
            },
            {
              lightness: '18'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xffffff'
            },
            {
              lightness: '16'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xf5f5f5'
            },
            {
              lightness: '21'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xdedede'
            },
            {
              lightness: '21'
            }
          ]
        },
        {
          featureType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '0xffffff'
            },
            {
              lightness: '16'
            }
          ]
        },
        {
          featureType: 'labels.text.fill',
          stylers: [
            {
              color: '0x7f7f7f'
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '0xf2f2f2'
            },
            {
              lightness: '19'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '0xfefefe'
            },
            {
              lightness: '20'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '0xfefefe'
            },
            {
              lightness: '17'
            },
            {
              weight: '1.2'
            }
          ]
        }
      ]
    }
  },
  components: {
    StaticMap
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      async handler () {
        const data = await getGeneralApplication()
        if (data && data.applicationUrl) {
          const sType = this.$route.query.sType
          this.href = sType ? `${data.applicationUrl}&sType=${sType}` : data.applicationUrl
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
$blockHeight: 480px;
.location {
  background: $c-bg-location;
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding:4rem;
    @media screen and (min-width: $mq-medium) {
      height: 100%;
      padding: 4rem 8rem;

    }
    h2 {
      font-size: 1.3rem;
      margin: 0;
    }
    p {
      font-size: 1.2rem;
    }
  }
  &__map {
    display: block;
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>
